import multiGuard from '@/router/utils/vue-router-multiguard'
import TabletGuard from '@/router/guards/tablet-guard'
import PackagePermissionsGuard from '@/router/guards/package-permissions-guard'
import customInputsAddonGuard from '@/router/guards/custom-inputs-addon-guard'
import { PACKAGE_PERMISSIONS } from '@/constants/features'
import SUBUSER_PERMISSION_SLUGS from '@/constants/authorization/subuser-permission-slugs'

export default [
  {
    path: 'users-wizard',
    name: 'admin:users-wizard',
    alias: '/admin/users',
    meta: { permission: SUBUSER_PERMISSION_SLUGS.SUBUSERS_VIEW },
    component: () => import(/* webpackChunkName: "basic-info" */ '@/views/admin/setup/account-basics/users-notifications/UsersNotificationsWizard.vue'),
  },
  {
    path: 'roles',
    name: 'admin:roles',
    alias: '/admin/roles',
    meta: { permission: SUBUSER_PERMISSION_SLUGS.ROLES_VIEW },
    redirect: { name: 'admin:users-wizard', query: { step: '2' } },
  },
  {
    path: 'services-wizard',
    name: 'admin:services-wizard',
    component: () => import(/* webpackChunkName: "ordering" */ '@/views/admin/setup/ordering/services/ServicesWizard.vue'),
  },
  {
    path: 'payment-methods-wizard',
    name: 'admin:payment-methods-wizard',
    component: () => import(/* webpackChunkName: "ordering" */ '@/views/admin/setup/ordering/payment-methods/PaymentMethodsWizard.vue'),
  },
  {
    path: 'vendor',
    name: 'admin:vendor',
    component: () => import(/* webpackChunkName: "ordering" */ '@/views/admin/setup/ordering/vendor-business-account/VendorBusinessAccountWizard.vue'),
  },
  {
    path: 'opening-hours',
    name: 'admin:opening-hours-wizard',
    component: () => import(/* webpackChunkName: "shifts" */ '@/views/admin/setup/organizing/opening-hours-scheduled-orders/OpeningHoursPage.vue'),
  },
  {
    path: 'my-menu',
    name: 'admin:my-menu',
    alias: '/admin/menu',
    meta: {
      hideFooter: true,
      collapseNavigation: true,
    },
    component: () => import(/* webpackChunkName: "my-menu" */ '@/views/admin/setup/menu-setup/my-menu/MyMenu.vue'),
  },
  {
    path: 'bulk-menu',
    name: 'admin:bulk-menu',
    meta: {
      hideFooter: true,
      permission: [
        SUBUSER_PERMISSION_SLUGS.MENU_BULK_VIEW,
        SUBUSER_PERMISSION_SLUGS.MENU_BULK_MANAGE,
      ],
    },
    component: () => import(/* webpackChunkName: "bulk-menu" */ '@/views/admin/setup/menu-setup/bulk-management/BulkMenuManagement.vue'),
  },
  {
    path: 'pos-menu',
    name: 'admin:pos-menu',
    alias: '/admin/pos-menu',
    meta: {
      hideFooter: true,
      collapseNavigation: true,
      pos: true,
    },
    component: () => import(/* webpackChunkName: "pos-menu" */ '@/views/admin/setup/menu-setup/my-menu/MyMenu.vue'),
  },
  {
    path: 'modifiers',
    name: 'admin:modifiers',
    alias: '/admin/modifiers',
    component: () => import(/* webpackChunkName: "modifiers" */ '@/views/admin/setup/menu-setup/modifiers/ModifiersTable.vue'),
  },
  {
    path: 'custom-inputs',
    name: 'admin:custom-inputs',
    alias: '/admin/custom-inputs',
    meta: {
      permission: SUBUSER_PERMISSION_SLUGS.CUSTOM_INPUTS_VIEW,
    },
    beforeEnter: multiGuard([customInputsAddonGuard, PackagePermissionsGuard]),
    component: () => import(/* webpackChunkName: "custom-inputs" */ '@/views/admin/setup/menu-setup/custom-inputs/CustomInputsTable.vue'),
  },
  {
    path: 'cloud',
    name: 'admin:cloud',
    component: () => import(/* webpackChunkName: "cloud" */ '@/views/admin/design/cloud/CloudWizard.vue'),
  },
  {
    path: 'cloud-table',
    name: 'admin:cloud-table',
    component: () => import(/* webpackChunkName: "cloud" */ '@/views/admin/design/cloud/CloudTable.vue'),
  },
  {
    path: 'taxes',
    name: 'admin:taxes',
    component: () => import(/* webpackChunkName: "taxes" */ '@/views/admin/setup/menu-setup/taxes/TaxPage.vue'),
  },
  {
    path: 'qr',
    name: 'admin:qr',
    component: () => import(/* webpackChunkName: "qr" */ '@/views/admin/setup/publishing/qr/QRCodeTable.vue'),
  },
  {
    path: 'devices',
    name: 'admin:devices',
    meta: {
      packagePermissions: [PACKAGE_PERMISSIONS.RESERVATION, PACKAGE_PERMISSIONS.QUEUE],
      permission: SUBUSER_PERMISSION_SLUGS.GENERAL_DEVICES_VIEW,
    },
    beforeEnter: multiGuard([TabletGuard, PackagePermissionsGuard]),
    component: () => import(/* webpackChunkName: "devices" */ '@/views/admin/setup/publishing/devices/DevicesTable.vue'),
  },
  {
    path: 'widget',
    name: 'admin:widget',
    component: () => import(/* webpackChunkName: "widget" */ '@/views/admin/setup/publishing/widget/WidgetWizard.vue'),
  },
  {
    path: 'domain',
    name: 'admin:domain',
    component: () => import(/* webpackChunkName: "domain" */ '@/views/admin/setup/publishing/domain/DomainWizard.vue'),
  },
  {
    path: 'google-menu',
    name: 'admin:google-menu',
    component: () => import(/* webpackChunkName: "google" */ '@/views/admin/setup/publishing/viral/GoogleMenuWizard.vue'),
  },
  {
    path: 'dynamic-links',
    name: 'admin:dynamic-links',
    component: () => import(/* webpackChunkName: "dynamicLinks" */ '@/views/admin/user/dynamic-links/UrlsTable.vue'),
  },
]
